export const GeneralLedgerCategories = {
    1: 'Sales',
    2: 'Purchase'
}
export const VatCategories = {
    1: 'Zero',
    2: 'Low',
    3: 'High'
}